import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { MasterService } from 'src/app/services/master/master.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import { ClientService } from 'src/app/services/clients/client.service';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-journey-span',
  templateUrl: './journey-span.component.html',
  styleUrls: ['./journey-span.component.css']
})
export class JourneySpanComponent extends BaseComponent implements OnInit {
  cp = 1;
  limit = 10;
  skip = 0;
  totalCount = 0;
  ord = 'asc';
  colname = "journey_name";
  getCompanyobj;
  public journeySpanObj: any = [];
  today: number = Date.now();
  companyID = 0;
  currentUser;
  checkCompany;
  companyid
  isSuperAdmin = false;
  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  journeyFilt: any;
  journeyDrpData: any;
  constructor(
    private master: MasterService,
    private ImportFilesDialogService: ImportFilesDialogService,
    private clientService: ClientService
  ) {
    super();
  }

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));
    this.companyID = this.currentUser.admin_customer_id;
    this.companyid = this.currentUser.admin_customer_id;
    this.isSuperAdmin = String(this.currentUser.admin_customer_id) === '0';
    if (this.currentUser.admin_customer_id != '0') {
      this.getJourneySpanData();
      this.JourneyLogData();
    }

    this.getCompany();
  }

  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.skip = 0;
          this.cp = 1;
          this.ngxSpinnerService.show();
        }),
        switchMap(data => this.master.getJourneySpanAll(this.companyID, this.limit, this.skip,''))
      )
      .subscribe(res => {
        if (res.status) {
          if (res.data.rows == null) { this.journeySpanObj = [] }
          else { this.journeySpanObj = res.data.rows }
          this.totalCount = res.data.total;
        } else {
          this.journeySpanObj = [];
          this.totalCount = 0;
        }
        this.ngxSpinnerService.hide();
      });
  }

  sorting(col: string) {
    this.colname = col
    if (this.ord == 'asc') {
      this.ord = 'desc'
    } else {
      this.ord = 'asc'
    }
    this.getJourneySpanData();
  }

  JourneyLogData() {
    let themeLogs = {
      log_type: "Journey Span Master View",
      log_name: "Journey Span Master View",
      log_description: "Journey Span Master View",
      moduleid: 1,
      moduleitemid: 7,
      per_id: 14
    }
    this.logs.addNewLogs(themeLogs).subscribe(data => {
      //  console.log(data);

    }, error => {
      // console.log(error);
    });

  }

  getJourneySpanData() {
    if(this.companyID == 0 ){return};
    this.ngxSpinnerService.show();
    let self = this;
    this.skip = (this.cp - 1) * this.limit;
    this.master.getJourneySpanAll(this.companyID, this.limit, this.skip,this.journeyFilt).subscribe(response => {
      self.journeySpanObj = response.data.rows;
      this.totalCount = response.data.total;
      this.ngxSpinnerService.hide();
    }, error => {
      // console.log(error);
      this.ngxSpinnerService.hide();
    });
  }
  onSelectCompany(id) {
    this.journeyFilt = '';
    if (id != 0) {
      this.companyID = id;
      this.getJourneySpanData();
      this.getJourneyList();
    } else { 
       this.journeySpanObj = [];this.totalCount = 0;this.cp = 1;
       this.ngxSpinnerService.hide(); }
  }
  deleteJourneySpan(id) {
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'ARE YOU SURE YOU WANT TO DELETE ?', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.deleteJourneySpan(id, this.companyID).subscribe(data => {
            if (data.status) {
              this.onSelectCompany(this.companyID);
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
            }
            this.ngxSpinnerService.hide();
          }, error => {
            // console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }
  editJourneySpan(id) {
    this.router.navigate(['/corporate/add-journey-span'], { queryParams: { journey_span_id: id, company: this.companyID } });
  }
  updateStatus(event, id) {
    event.preventDefault();
    let obj = this.journeySpanObj.find(element => {
      // console.log(element.get_master_company_type.company_type_id)
      if (element.journey_id === id) {
        return true;
      }
    });
    //obj = obj.get_master_journey;

    // console.log("*********", obj)

    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to change the status? ', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          obj.isactive = !obj.isactive;
          obj.company = this.companyID;
          this.master.updateJourney(obj).subscribe(data => {
            this.onSelectCompany(this.companyID);
            this.toastrService.success("Journey Master Status Changed Successfully");
          });
        }
        // else {
        //   this.master.updateJourney(obj).subscribe(data => {
        //     this.getJourney();
        //   });
        // }
      }).catch(() => {
        //  console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });
  }
  setValue(event) {
    let self = this;
    let url = event.target.src;
    if (url.indexOf("master_images") > 0) {
      url = url.substring(url.indexOf("master_images"), url.length);
      if (!this.isUrlValid(url)) {
        let awsUrl = self.master.getUrlfile(url);
        event.target.src = self.isUrlValid(awsUrl) ? awsUrl : '../../../assets/custom/images/broken.png';
      } else {
        event.target.src = '../../../assets/custom/images/broken.png';
      }
    } else {
      event.target.src = '../../../assets/custom/images/broken.png';
    }
    event.target.onerror = null;
  }
  isUrlValid(userInput) {
    return /(https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(userInput);
  }
  getCompany() {

    let self = this;
    this.clientService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self, (id) => { self.onSelectCompany(id); });

      // console.log(self.getCompanyobj);
    }, error => {
      // console.log(error);
    });
  }
  getJourneyList(){
    this.ngxSpinnerService.show();
    this.master.getJourneyAll(this.companyID,1000,0,'journey_name','asc','').subscribe(res => {
      if(res.data){
      this.journeyDrpData = res.data?.rows.filter(item=>item.journey_parent_id == 0 );
      }else{
        this.journeyDrpData=[];
      }
      this.ngxSpinnerService.hide();
    }, error => {
      console.log("errorrrr");
      this.journeyDrpData=[];
      this.ngxSpinnerService.hide();
    });
}
  getListForJourney(journey:any){
    this.journeyFilt = journey;
    this.getJourneySpanData();
  }
}
